import React from "react";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center">
      <h1 className="text-3xl font-bold">Terms of Service Page</h1>
    </div>
  );
};

export default TermsOfService;
